import { useCallback } from 'react';
import { useAppConfiguration, useCarleadHashParam, useTrackEvent } from '@wkda/funnel-components';

/**
 * Hook to track element click events.
 *
 * @param {Object} options - Tracking options
 * @param {string | ((...args: any[]) => string)} [options.label] - Event label, or function called with trackClick(...args) to compute label
 * @param {string} [options.category = 'Handover Page'] - Event data category
 * @param {string} [options.action = 'Click'] - Event data action
 * @returns {(...args: any[]) => void} trackClick - Call with no args, or pass args if label is a function (e.g. trackClick(isShowMore))
 */
export const useTrackElementClick = (options = {}) => {
  const {
    label = 'CTA',
    category = 'Handover Page',
    action = 'Click'
  } = options;
  const track = useTrackEvent();
  const {
    trackLandingPageType
  } = useAppConfiguration();
  const hash = useCarleadHashParam();
  return useCallback((...args) => {
    track({
      action: 'eventTracking',
      category: trackLandingPageType,
      eventData: {
        category,
        action,
        label: typeof label === 'function' ? label(...args) : label,
        ...(hash && {
          hash
        })
      }
    });
  }, [track, trackLandingPageType, hash, category, action, label]);
};